export default __webpack_public_path__ + "static/media/flag-es-LT.f06eae4e.png";